// @ts-nocheck
import * as Types from '../../../../generated/graphqlTypes';

import { gql } from '@apollo/client';
import { NamedFragmentDoc } from '../../../../fragments/commonFragments.generated';
import * as Apollo from '@apollo/client';
import * as ApolloReactHooks from 'src/apolloHooks';
const defaultOptions = {} as const;
export type AssignTradeContacts_BidPackageGroupQueryVariables = Types.Exact<{
  id: Types.Scalars['ID']['input'];
}>;


export type AssignTradeContacts_BidPackageGroupQuery = { __typename?: 'Query', bidPackageGroup: { __typename?: 'BidPackageGroup', id: string, bidPackages: Array<{ __typename?: 'BidPackage', id: string, name: string, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, tradePartnerMarketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string }, market: { __typename?: 'Market', id: string } }> }> } }>, relevantMarket: { __typename?: 'Market', id: string } }> }, markets: Array<{ __typename?: 'Market', id: string, name: string }> };

export type AssignTradeContacts_BidPackageFragment = { __typename?: 'BidPackage', id: string, name: string, requests: Array<{ __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, tradePartnerMarketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string }, market: { __typename?: 'Market', id: string } }> }> } }>, relevantMarket: { __typename?: 'Market', id: string } };

export type AssignTradeContacts_BidPackageRequestFragment = { __typename?: 'BidPackageRequest', id: string, tradePartner: { __typename?: 'TradePartner', id: string, name: string, contacts: Array<{ __typename?: 'TradePartnerContact', id: string, name: string, tradePartnerMarketContacts: Array<{ __typename?: 'TradePartnerMarketContact', id: string, role: { __typename?: 'TradePartnerMarketRoleDetail', code: Types.TradePartnerMarketRole, name: string }, market: { __typename?: 'Market', id: string } }> }> } };

export const AssignTradeContacts_BidPackageRequestFragmentDoc = gql`
    fragment AssignTradeContacts_BidPackageRequest on BidPackageRequest {
  id
  tradePartner {
    id
    name
    contacts {
      tradePartnerMarketContacts {
        id
        role {
          code
          name
        }
        market {
          id
        }
      }
      id
      name
    }
  }
}
    `;
export const AssignTradeContacts_BidPackageFragmentDoc = gql`
    fragment AssignTradeContacts_BidPackage on BidPackage {
  id
  name
  requests {
    ...AssignTradeContacts_BidPackageRequest
  }
  relevantMarket {
    id
  }
}
    ${AssignTradeContacts_BidPackageRequestFragmentDoc}`;
export const AssignTradeContacts_BidPackageGroupDocument = gql`
    query AssignTradeContacts_BidPackageGroup($id: ID!) {
  bidPackageGroup(id: $id) {
    id
    bidPackages {
      ...AssignTradeContacts_BidPackage
    }
  }
  markets {
    ...Named
  }
}
    ${AssignTradeContacts_BidPackageFragmentDoc}
${NamedFragmentDoc}`;

/**
 * __useAssignTradeContacts_BidPackageGroupQuery__
 *
 * To run a query within a React component, call `useAssignTradeContacts_BidPackageGroupQuery` and pass it any options that fit your needs.
 * When your component renders, `useAssignTradeContacts_BidPackageGroupQuery` returns an object from Apollo Client that contains loading, error, and data properties
 * you can use to render your UI.
 *
 * @param baseOptions options that will be passed into the query, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options;
 *
 * @example
 * const { data, loading, error } = useAssignTradeContacts_BidPackageGroupQuery({
 *   variables: {
 *      id: // value for 'id'
 *   },
 * });
 */
export function useAssignTradeContacts_BidPackageGroupQuery(baseOptions: ApolloReactHooks.QueryHookOptions<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables> & ({ variables: AssignTradeContacts_BidPackageGroupQueryVariables; skip?: boolean; } | { skip: boolean; }) ) {
        const options = {...defaultOptions, ...baseOptions}
        return ApolloReactHooks.useQuery<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>(AssignTradeContacts_BidPackageGroupDocument, options);
      }
export function useAssignTradeContacts_BidPackageGroupLazyQuery(baseOptions?: ApolloReactHooks.LazyQueryHookOptions<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>) {
          const options = {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useLazyQuery<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>(AssignTradeContacts_BidPackageGroupDocument, options);
        }
// @ts-ignore
export function useAssignTradeContacts_BidPackageGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SuspenseQueryHookOptions<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>;
export function useAssignTradeContacts_BidPackageGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>): ApolloReactHooks.UseSuspenseQueryResult<AssignTradeContacts_BidPackageGroupQuery | undefined, AssignTradeContacts_BidPackageGroupQueryVariables>;
export function useAssignTradeContacts_BidPackageGroupSuspenseQuery(baseOptions?: ApolloReactHooks.SkipToken | ApolloReactHooks.SuspenseQueryHookOptions<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>) {
          const options = baseOptions === ApolloReactHooks.skipToken ? baseOptions : {...defaultOptions, ...baseOptions}
          return ApolloReactHooks.useSuspenseQuery<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>(AssignTradeContacts_BidPackageGroupDocument, options);
        }
export type AssignTradeContacts_BidPackageGroupQueryHookResult = ReturnType<typeof useAssignTradeContacts_BidPackageGroupQuery>;
export type AssignTradeContacts_BidPackageGroupLazyQueryHookResult = ReturnType<typeof useAssignTradeContacts_BidPackageGroupLazyQuery>;
export type AssignTradeContacts_BidPackageGroupSuspenseQueryHookResult = ReturnType<typeof useAssignTradeContacts_BidPackageGroupSuspenseQuery>;
export type AssignTradeContacts_BidPackageGroupQueryResult = Apollo.QueryResult<AssignTradeContacts_BidPackageGroupQuery, AssignTradeContacts_BidPackageGroupQueryVariables>;